<template><div><h3>Confirm_COM</h3>
<img width="100" src="http://qr.topscan.com/api.php?text=https%3A%2F%2Fvux.li%2Fdemos%2Fv2%2F%23%2Fcomponent%2Fconfirm"/>
<p><a href="https://vux.li/demos/v2/#/component/confirm" target="_blank" style="font-size:12px;color:#888;">demo 原始链接：https://vux.li/demos/v2/#/component/confirm</a></p>
<hr>
<h4>演示</h4>
 <div style="width:377px;height:667px;display:inline-block;border:1px dashed #ececec;border-radius:5px;overflow:hidden;">
   <iframe src="https://vux.li/demos/v2/#/component/confirm" width="375" height="667" border="0" frameborder="0"></iframe>
 </div>
<h4>demo 代码</h4>
<p class="tip">下面的$t是Demo的i18n使用的翻译函数，一般情况下可以直接使用字符串。另外，下面代码隐藏了i18n标签部分的代码。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">group</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">x-switch</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Toggle')"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"show"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-switch</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">group</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">x-switch</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Toggle show-input')"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"show3"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-switch</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">group</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">x-switch</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Set default input value')"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"show5"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-switch</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">group</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">x-switch</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Toggle_android')"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"show2"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-switch</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">group</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">x-switch</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('closeOnConfirm=false')"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"show4"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-switch</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">v-transfer-dom</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">confirm</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"show"</span>
      <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Confirm deleting the item')"</span>
      <span class="hljs-attr">@on-cancel</span>=<span class="hljs-string">"onCancel"</span>
      <span class="hljs-attr">@on-confirm</span>=<span class="hljs-string">"onConfirm"</span>
      <span class="hljs-attr">@on-show</span>=<span class="hljs-string">"onShow"</span>
      <span class="hljs-attr">@on-hide</span>=<span class="hljs-string">"onHide"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">p</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"text-align:center;"</span>&gt;</span><span>{{</span> $t('Are you sure?') <span>}}</span><span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">confirm</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">br</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">v-transfer-dom</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">confirm</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"show3"</span>
      <span class="hljs-attr">show-input</span>
      <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Confirm deleting the item')"</span>
      <span class="hljs-attr">:input-attrs</span>=<span class="hljs-string">"{type: 'number'}"</span>
      <span class="hljs-attr">@on-cancel</span>=<span class="hljs-string">"onCancel"</span>
      <span class="hljs-attr">@on-confirm</span>=<span class="hljs-string">"onConfirm"</span>
      <span class="hljs-attr">@on-show</span>=<span class="hljs-string">"onShow"</span>
      <span class="hljs-attr">@on-hide</span>=<span class="hljs-string">"onHide"</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">confirm</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">br</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">v-transfer-dom</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">confirm</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"show5"</span>
      <span class="hljs-attr">show-input</span>
      <span class="hljs-attr">ref</span>=<span class="hljs-string">"confirm5"</span>
      <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Confirm deleting the item')"</span>
      <span class="hljs-attr">@on-cancel</span>=<span class="hljs-string">"onCancel"</span>
      <span class="hljs-attr">@on-confirm</span>=<span class="hljs-string">"onConfirm5"</span>
      <span class="hljs-attr">@on-show</span>=<span class="hljs-string">"onShow5"</span>
      <span class="hljs-attr">@on-hide</span>=<span class="hljs-string">"onHide"</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">confirm</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">br</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">v-transfer-dom</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">confirm</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"show2"</span>
      <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Confirm deleting the item')"</span>
      <span class="hljs-attr">theme</span>=<span class="hljs-string">"android"</span>
      <span class="hljs-attr">@on-cancel</span>=<span class="hljs-string">"onCancel"</span>
      <span class="hljs-attr">@on-confirm</span>=<span class="hljs-string">"onConfirm"</span>
      <span class="hljs-attr">@on-show</span>=<span class="hljs-string">"onShow"</span>
      <span class="hljs-attr">@on-hide</span>=<span class="hljs-string">"onHide"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">p</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"text-align:center;"</span>&gt;</span><span>{{</span> $t('I miss u sunyi') <span>}}</span><span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">confirm</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">br</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">v-transfer-dom</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">confirm</span>
      <span class="hljs-attr">v-model</span>=<span class="hljs-string">"show4"</span>
      <span class="hljs-attr">:close-on-confirm</span>=<span class="hljs-string">"false"</span>
      <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Confirm deleting the item')"</span>
      <span class="hljs-attr">@on-confirm</span>=<span class="hljs-string">"onConfirm4"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">p</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"text-align:center;"</span>&gt;</span><span>{{</span> $t('Are you sure?') <span>}}</span><span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">confirm</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">br</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"padding:15px;"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">x-button</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"showPlugin"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span>&gt;</span><span>{{</span> $t('Show') <span>}}</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-button</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"padding:15px;"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">x-button</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"showPlugin2"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span>&gt;</span><span>{{</span> $t('Plugin usage') <span>}}</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-button</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"padding:15px;"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">x-button</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"showPlugin3"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span>&gt;</span> <span>{{</span> $t('Call prompt by using plugin') <span>}}</span> <span class="hljs-tag">&lt;/<span class="hljs-name">x-button</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>



<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">import</span> { Confirm, Group, XSwitch, XButton, TransferDomDirective <span class="hljs-keyword">as</span> TransferDom } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">directives</span>: {
    TransferDom
  },
  <span class="hljs-attr">components</span>: {
    Confirm,
    Group,
    XSwitch,
    XButton
  },
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">show</span>: <span class="hljs-literal">false</span>,
      <span class="hljs-attr">show2</span>: <span class="hljs-literal">false</span>,
      <span class="hljs-attr">show3</span>: <span class="hljs-literal">false</span>,
      <span class="hljs-attr">show4</span>: <span class="hljs-literal">false</span>,
      <span class="hljs-attr">show5</span>: <span class="hljs-literal">false</span>
    }
  },
  <span class="hljs-attr">methods</span>: {
    onCancel () {
      <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'on cancel'</span>)
    },
    onConfirm (msg) {
      <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'on confirm'</span>)
      <span class="hljs-keyword">if</span> (msg) {
        alert(msg)
      }
    },
    onConfirm4 () {
      <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'on confirm'</span>)
      <span class="hljs-keyword">this</span>.$vux.loading.show({
        <span class="hljs-attr">transition</span>: <span class="hljs-string">''</span>,
        <span class="hljs-attr">text</span>: <span class="hljs-string">'processing'</span>
      })
      setTimeout(<span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
        <span class="hljs-keyword">this</span>.$vux.loading.hide()
        <span class="hljs-keyword">this</span>.show4 = <span class="hljs-literal">false</span>
      }, <span class="hljs-number">1000</span>)
    },
    onHide () {
      <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'on hide'</span>)
    },
    onShow () {
      <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'on show'</span>)
    },
    onShow5 () {
      <span class="hljs-keyword">this</span>.$refs.confirm5.setInputValue(<span class="hljs-string">'default'</span>)
    },
    onConfirm5 (value) {
      <span class="hljs-keyword">this</span>.$refs.confirm5.setInputValue(<span class="hljs-string">''</span>)
      <span class="hljs-keyword">this</span>.$vux.toast.text(<span class="hljs-string">'input value: '</span> + value)
    },
    showPlugin () {
      <span class="hljs-keyword">this</span>.$vux.confirm.show({
        <span class="hljs-attr">title</span>: <span class="hljs-string">'Title'</span>,
        <span class="hljs-attr">content</span>: <span class="hljs-string">'Content'</span>,
        onShow () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'plugin show'</span>)
        },
        onHide () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'plugin hide'</span>)
        },
        onCancel () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'plugin cancel'</span>)
        },
        onConfirm () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'plugin confirm'</span>)
        }
      })
    },
    showPlugin2 () {
      <span class="hljs-keyword">this</span>.showPlugin()
    },
    showPlugin3 () {
      <span class="hljs-keyword">const</span> _this = <span class="hljs-keyword">this</span>
      <span class="hljs-keyword">this</span>.$vux.confirm.prompt(<span class="hljs-string">'123'</span>, {
        <span class="hljs-attr">title</span>: <span class="hljs-string">'Title'</span>,
        onShow () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'promt show'</span>)
          _this.$vux.confirm.setInputValue(<span class="hljs-string">'set input value'</span>)
        },
        onHide () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'prompt hide'</span>)
        },
        onCancel () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'prompt cancel'</span>)
        },
        onConfirm (msg) {
          alert(msg)
        }
      })
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

</code></pre>
<h4>Github Issue</h4>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// confirm-370.vue?33d56164